module.exports = __webpack_public_path__ + "img/logo2.7b07ac6c.png";